import { createContext, useState } from "react";
import settings from "../settings";

// 1. Create the context
export const SearchContext = createContext();

// 2. Provide the context
export const SearchProvider = ({ children }) => {
  const [searchState, setSearchState] = useState({
    searchByNameVisible: false,
    city: settings.citiesTags[0],
    guests: 1,
    startDate: null,
    endDate: null,
    cities: settings.citiesTags.filter(({ visible }) => visible).map((city) => city),
    tags: [],
    properties: [],
    mapProperties: [],
    bedrooms: [],
    totalProperties: 0,
    sortMethod: settings.sortMethods[0],
    page: 1,
    searchText: "",
    downloadingItems: true,
    downloadingMapItems: true,
    getListingParams: {},
    paramObj: { title: document?.title, city: "dubai", tags: undefined },
  });

  return (
    <SearchContext.Provider value={{ searchState, setSearchState }}>
      {children}
    </SearchContext.Provider>
  );
};
